import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import CoordinatorListingTabs from './CoordinatorListingTabs';

const Index = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>ViewRegisteredExamsListing.RegisteredExams')} />
      <CoordinatorListingTabs />
    </>
  );
};

export default Index;
